module.exports = __webpack_public_path__ + "img/startusing.934cbf34.png";